import { QueovalBase, QueovalDate} from '../global/class.global';
import { TDOClient, TDOProduction, TDOInfosFiscalAGACGA } from '../global/tables.global';

export class ConditionModel extends QueovalBase {
  public deleteSuccessfully: boolean;
  public Conditions2: NewConditionModel;
  public ColumnsOfTables: Array<ConditionColumnsModel>;
  public lstDocuments: Array<ConditionDocumentsModel>;
  public contexts: Array<ConditionContext>;
  constructor() {
    super();
    this.Conditions2 = new NewConditionModel();
    this.ColumnsOfTables = new Array<ConditionColumnsModel>();
    this.lstDocuments = new Array<ConditionDocumentsModel>();
    this.contexts = new Array<ConditionContext>();
  }
}

export class ConditionContext {
  public bo: string;
  public name: string;
  public value: string;
  public table: string;
  constructor(bo: string = "", name: string = "", value: string = "", table: string = "") {
    this.bo = bo;
    this.name = name;
    this.value = value;
    this.table = table;
  }
}

export class NewConditionModel {
  public strName: string;
  public strDescription: string;
  public lstConditions: Array<SubModel2>;
  constructor() {
    this.strName = '';
    this.strDescription = '';
    this.lstConditions = new Array<SubModel2>();
  }
}
export class SubModel2 {
  public editable: boolean;
  public ident: number;
  public andOrOperator: string;
  public context: string;
  public name: string;
  public logicalOperator: string;
  public value: string;
  constructor() {
    this.andOrOperator = '';
    this.context = '';
    this.name = '';
    this.logicalOperator = '';
    this.value = '';
  }
}
  
export class ConditionColumnsModel {
  public tableName: string;
  public lstColumns: Map<string, string>;
  constructor() {
    this.tableName = '';
    this.lstColumns = new Map<string, string>();
  }
}
export class ConditionDocumentsModel {
  public ident: string;
  public name: string;
  public date: QueovalDate;
}
